import React, { memo } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// styles
import { Container, ImageContainer, StyledText } from "./styles";
// constants
import { COUPON_SECTION_HEADER_COMMS_DATA_TEST_ID as TEST_ID } from "@swiggy-private/cart-test-ids";
import { IHeaderFooterComm } from "@swiggy-private/cart-types";

const CouponHeaderSection = (comms: IHeaderFooterComm) => {
    if (isEmpty(comms.staticSavingsText)) {
        return null;
    }

    return (
        <Container data-testid={TEST_ID.CONTAINER}>
            {!isEmpty(comms.headerImage?.icon) && (
                <ImageContainer
                    data-testid={TEST_ID.IMAGE}
                    height={comms.headerImage?.height}
                    width={comms.headerImage?.width}
                >
                    <Image cloudinaryId={comms.headerImage?.icon} width={"100%"} height={"100%"} />
                </ImageContainer>
            )}
            <StyledText
                textAlign="center"
                variant="V2.body1.neutral.bold"
                color="text_Highest_Emphasis"
                data-testid={TEST_ID.TEXT}
            >
                {comms.staticSavingsText}
            </StyledText>
        </Container>
    );
};

export default memo(CouponHeaderSection);
